/**
 * Utils class
 */
class Utils {
  /**
   * ExtractFileNameFromPath
   *
   * @param {string} path
   * @param {boolean} keepExtension
   * @returns {string | null}
   */
  public static extractFileNameFromPath(path: string, keepExtension = true): string | null {
    const regex = /(^.*[\\/])/g;
    const regexResult = regex.exec(path);
    if (regexResult && regexResult[0]) {
      if (keepExtension === true) {
        return path.replace(regexResult[0], '');
      }
      const extension = Utils.extractFileExtensionFromPath(path);
      return path.replace(regexResult[0], '').replace(`.${extension}`, '');
    }

    return null;
  }

  /**
   * ExtractFileExtension
   *
   * @param {string} path
   * @returns {string | null}
   */
  public static extractFileExtensionFromPath(path: string): string | null {
    const regex = /(?:\.([^.]+))?$/;
    const regexResult = regex.exec(path);
    if (regexResult[1]) {
      return regexResult[1];
    }
    return null;
  }

  /**
   * capitalize
   *
   * @param {unknown} string
   * @returns {string}
   */
  public static capitalize(string: unknown): string {
    if (typeof string !== 'string') {
      return '';
    }

    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * snakeToCamelCase
   *
   * @param {string} str
   * @returns {string}
   */
  public static snakeToCamelCase(str: string): string {
    return str.replace(/([-_][a-z0-9])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
  }
}

export { Utils };
